import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  borderTop: (p) => `1px solid ${p.palette.grey[300]}`,
  padding: (p) => p.spacing(1),
};
